import React from 'react';
import ByteInsights from './ByteInsights';
import ByteChat from './ByteChat';
import './ByteCompanion.css';

/**
 * ByteCompanion
 * Right-pane coaching companion shown alongside the code in Learn Mode.
 *
 * Composes:
 *   • Header (Byte badge + pulse + status line)
 *   • ByteInsights (3–5 numbered takeaways, with a "Generate Insights"
 *     CTA when no cached explanation exists for the current card)
 *   • ByteChat (template prompt chips — free-form chat removed for MVP)
 *
 * Visibility, caching, and AI gating are all controlled by the parent
 * (`Study.js`). This component is purely presentational.
 */
const ByteCompanion = ({
  badgeLabel = 'Byte',
  statusLabel,
  isLive = true,

  explanation,
  isLoadingInsights = false,
  insightsError = false,
  onGenerateInsights,
  onRegenerateInsights,
  generateDisabled = false,

  chatChips = [],
  onAsk,
  chatDisabled = false,

  className = ''
}) => {
  return (
    <aside
      className={`byte-companion ${className}`.trim()}
      aria-label="Byte coaching panel"
    >
      <div className="byte-companion__header">
        <span className="byte-companion__badge">{badgeLabel}</span>
        {isLive && (
          <span
            className="byte-companion__pulse"
            aria-hidden="true"
            title="Byte is live"
          />
        )}
        {statusLabel && (
          <span className="byte-companion__status">{statusLabel}</span>
        )}
      </div>

      <div className="byte-companion__body">
        <ByteInsights
          explanation={explanation}
          isLoading={isLoadingInsights}
          hasError={insightsError}
          onGenerate={onGenerateInsights}
          onRegenerate={onRegenerateInsights}
          generateDisabled={generateDisabled}
        />
      </div>

      <div className="byte-companion__chat-section">
        <ByteChat
          chips={chatChips}
          onAsk={onAsk}
          disabled={chatDisabled}
        />
      </div>
    </aside>
  );
};

export default ByteCompanion;
